<template>
    <div class="comp_cont">

        <table class="tblSteps" cellspacing="0" cellpadding="0">
            <tr>
                <td v-for="(step, index)  in steps" v-bind:key="index" 
                :class="['stepcol', step.tipus==1 ? 'col_step' : ''
                ]" 

                v-show="!(index==0&step.tipus==0)"
                >
                    <span v-show="step.tipus==1" 
                        :class="['stepcont', 
                        (step.tipus==1&&step.num<=value) ? 'stepcont_active' : '',
                        ]"                     
                    >
                        {{step.num}}
                    </span>

                    <div v-show="step.tipus==0"
                        :class="['line', 
                        (step.tipus==0&&step.num<=value) ? 'line_active' : '',
                        ]"                              
                    >&nbsp;</div>

                </td>


            </tr>
        </table>

        <div class="titlecont">
            <div v-for="(title, titleindex)  in titles" v-bind:key="titleindex" class="titlecell"
            v-bind:style="{ 'width': ((titleindex==0)||(titleindex==titles.length-1)) ? titlecol_length_szelso : titlecol_length, 'text-align': title.textalign }"
            >
                <span :class="['titlefont', (title.num==value) ? 'title_active' : '' ]"                     
                >
                    {{title.text}}
                </span>
            </div>
        </div>

    </div>
</template>

<script>


export default {
  name: 'GrcStepProgress',
  components: {
  },
  props: {
  },
  data () {
      return {
          steps: [],
          titles:[],
          value:-1,
          titlecol_length:"0%",
          titlecol_length_szelso:"0%",
          StepIconColWidth: 40,

      }
  },
  model: {
  },  
  methods:{
      Init(pSteps)
      {
          this.value = -1;
          this.steps = [];
          this.titles = [];

          if (pSteps.length == 0)
          {
              this.titlecol_length = "0%";
          }
          else
          {
              if (pSteps.length == 2)
              {
                  this.titlecol_length = "50%";
                  this.titlecol_length_szelso = "50%";
              }
              else
              {
                var L = pSteps.length;
                var SW = this.StepIconColWidth;

                var SzelsoSzazalek =  50 / (L-1);
                var SzelsoPixel = 0 - (SW / (L-1)) + SW;
                SzelsoPixel = SzelsoPixel / 2;

                this.titlecol_length_szelso = "calc("+SzelsoSzazalek+"% + " + SzelsoPixel+"px)";

                var KoztesSzazalek = (100 - (SzelsoSzazalek*2)) / (L-2);
                var KoztesPixel = 2 * SzelsoPixel / (L-2);

                this.titlecol_length = "calc("+KoztesSzazalek+"% - " + KoztesPixel+"px)";
              }

              
          }

          //console.log(this.titlecol_length_szelso);
          //console.log(this.titlecol_length);

          for(var i=0; i<pSteps.length; i++)
          {
              var step = { tipus: 0, num:i+1  };
              this.steps.push(step);

              step = { tipus: 1, num:i+1  };
              this.steps.push(step);
          }

          for(var i=0; i<pSteps.length; i++)
          {
              var textalign = "center";
              if (i == 0) { textalign = "left"; }
              if (i == pSteps.length-1) { textalign = "right"; }

              var title = { text:pSteps[i].text, num:i+1, textalign:textalign  };
              this.titles.push(title);
          }

          if (pSteps.length>0) { this.value = 1; }

      },

      SetValue(pValue)
      {
          this.value = pValue;
      }

  },
  created()
  {

  },
  mounted()
  {

  }

}


</script>


<style scoped>

.comp_cont
{
    width:100%;
    box-sizing: border-box;
}

.tblSteps
{
    width:100%;
}

.stepcol
{
    text-align: center;
}

.col_step
{
    width:40px;
}

.stepcont
{
    width: 32px;
    height: 32px;
    font-size: 17px;
    line-height: 32px;
    text-align: center;
    border-radius: 32px;
    transition: background-color .3s,border-color .3s;
    display:inline-block;
    border:solid 1px #ccc;
    color:#444;
    font-family: Arial;
}

.stepcont_active
{
    background-color:var(--themecolor3);
    color:#fff;
    border:solid 1px var(--themecolor3);
}

.line
{
    width:100%;
    box-sizing: border-box;
    height:1px;
    border-bottom:solid 3px #ccc;
}

.line_active
{
    border-bottom:solid 3px var(--themecolor3);
}

.titlecont
{
    width:100%;
    box-sizing: border-box;
    padding:0px;
    border:none;
    margin-top:4px;
}

.titlecell
{
    vertical-align: top;
    padding:0px 4px;
    display:inline-block;
    box-sizing: border-box;
}





.titlefont
{
    font-family: "CmsDefault", Verdana;
    font-size:13px;
    line-height: 15px;
    color:#ccc;
    display: block;
    box-sizing: border-box;
}

.title_active
{
    font-weight: 500;
    color:#444;
}

@media(max-width:600px)
{
    .titlecell
    {
        display:none;
    }
}


</style>